export const isFetching = state => state.credentials.orders.fetching;
export const orders = state => state.credentials.orders.list;
export const references = state => state.credentials.orders.references;
export const fields = state => state.credentials.orders.fields;
export const meta = state => state.credentials.orders.meta;
